"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.preload = preload;
const electron_1 = require("@theia/core/electron-shared/electron");
const disposable_1 = require("@theia/core/lib/common/disposable");
const electron_api_1 = require("@theia/core/lib/electron-common/electron-api");
const coreutils_1 = require("@theia/core/shared/@phosphor/coreutils");
const electron_arduino_1 = require("../electron-common/electron-arduino");
const startup_task_1 = require("../electron-common/startup-task");
let mainMenuHandlers = new Map();
function convertMenu(menu, handlerMap) {
    if (!menu) {
        return undefined;
    }
    return menu.map((item) => {
        let nodeId = coreutils_1.UUID.uuid4();
        if (item.execute) {
            if (!item.id) {
                throw new Error("A menu item having the 'execute' property must have an 'id' too.");
            }
            nodeId = item.id;
            handlerMap.set(nodeId, item.execute);
        }
        return {
            id: item.id,
            submenu: convertMenu(item.submenu, handlerMap),
            accelerator: item.accelerator,
            label: item.label,
            nodeId,
            checked: item.checked,
            enabled: item.enabled,
            role: item.role,
            type: item.type,
            visible: item.visible,
        };
    });
}
const api = {
    showMessageBox: (options) => electron_1.ipcRenderer.invoke(electron_arduino_1.CHANNEL_SHOW_MESSAGE_BOX, options),
    showOpenDialog: (options) => electron_1.ipcRenderer.invoke(electron_arduino_1.CHANNEL_SHOW_OPEN_DIALOG, options),
    showSaveDialog: (options) => electron_1.ipcRenderer.invoke(electron_arduino_1.CHANNEL_SHOW_SAVE_DIALOG, options),
    appInfo: () => electron_1.ipcRenderer.invoke(electron_arduino_1.CHANNEL_APP_INFO),
    quitApp: () => electron_1.ipcRenderer.send(electron_arduino_1.CHANNEL_QUIT_APP),
    isFirstWindow: () => electron_1.ipcRenderer.invoke(electron_arduino_1.CHANNEL_IS_FIRST_WINDOW),
    requestReload: (options) => electron_1.ipcRenderer.send(electron_api_1.CHANNEL_REQUEST_RELOAD, options),
    registerStartupTasksHandler: (handler) => {
        const listener = (_, args) => {
            if ((0, startup_task_1.hasStartupTasks)(args)) {
                handler(args);
            }
            else {
                console.warn(`Events received on the ${electron_arduino_1.CHANNEL_SEND_STARTUP_TASKS} channel expected to have a startup task argument, but it was: ${JSON.stringify(args)}`);
            }
        };
        electron_1.ipcRenderer.on(electron_arduino_1.CHANNEL_SEND_STARTUP_TASKS, listener);
        return disposable_1.Disposable.create(() => electron_1.ipcRenderer.removeListener(electron_arduino_1.CHANNEL_SEND_STARTUP_TASKS, listener));
    },
    scheduleDeletion: (sketch) => electron_1.ipcRenderer.send(electron_arduino_1.CHANNEL_SCHEDULE_DELETION, sketch),
    setRepresentedFilename: (fsPath) => electron_1.ipcRenderer.send(electron_arduino_1.CHANNEL_SET_REPRESENTED_FILENAME, fsPath),
    showPlotterWindow: (params) => electron_1.ipcRenderer.send(electron_arduino_1.CHANNEL_SHOW_PLOTTER_WINDOW, params),
    registerPlotterWindowCloseHandler: (handler) => {
        const listener = () => handler();
        electron_1.ipcRenderer.on(electron_arduino_1.CHANNEL_PLOTTER_WINDOW_DID_CLOSE, listener);
        return disposable_1.Disposable.create(() => electron_1.ipcRenderer.removeListener(electron_arduino_1.CHANNEL_PLOTTER_WINDOW_DID_CLOSE, listener));
    },
    openPath: (fsPath) => electron_1.ipcRenderer.send(electron_arduino_1.CHANNEL_OPEN_PATH, fsPath),
    setMenu: (menu) => {
        mainMenuHandlers = new Map();
        const internalMenu = convertMenu(menu, mainMenuHandlers);
        electron_1.ipcRenderer.send(electron_arduino_1.CHANNEL_SET_MENU_WITH_NODE_ID, internalMenu);
    },
};
function preload() {
    electron_1.contextBridge.exposeInMainWorld('electronArduino', api);
    electron_1.ipcRenderer.on(electron_arduino_1.CHANNEL_MAIN_MENU_ITEM_DID_CLICK, (_, nodeId) => {
        const handler = mainMenuHandlers.get(nodeId);
        if (handler) {
            handler();
        }
    });
    console.log('Exposed Arduino IDE electron API');
}
//# sourceMappingURL=preload.js.map